import { render, staticRenderFns } from "./ComponentFrame.vue?vue&type=template&id=3da171cf&scoped=true"
import script from "./ComponentFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponentFrame.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ComponentFrame.vue?vue&type=style&index=0&id=3da171cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da171cf",
  null
  
)

export default component.exports